var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-12 h-12 rounded-full flex justify-center text-center items-center",class:'bg-' + _vm.background},[_c('font-awesome-icon',{staticClass:"text-xl",class:'text-' + _vm.color,attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }